'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002etemporal$002e$002dValue$002dRange from "./java.time.temporal.-Value-Range.js";
var $p;
/** @constructor */
function $c_Ljava_time_temporal_ValueRange$() {
}
export { $c_Ljava_time_temporal_ValueRange$ as $c_Ljava_time_temporal_ValueRange$ };
$p = $c_Ljava_time_temporal_ValueRange$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_temporal_ValueRange$;
/** @constructor */
function $h_Ljava_time_temporal_ValueRange$() {
}
export { $h_Ljava_time_temporal_ValueRange$ as $h_Ljava_time_temporal_ValueRange$ };
$h_Ljava_time_temporal_ValueRange$.prototype = $p;
$p.b1 = (function(min_$_lo, min_$_hi, max_$_lo, max_$_hi) {
  if (((min_$_hi === max_$_hi) ? ((min_$_lo >>> 0) > (max_$_lo >>> 0)) : (min_$_hi > max_$_hi))) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), "Minimum value must be less than maximum value");
  } else {
    return new $j_java$002etime$002etemporal$002e$002dValue$002dRange.$c_Ljava_time_temporal_ValueRange(min_$_lo, min_$_hi, min_$_lo, min_$_hi, max_$_lo, max_$_hi, max_$_lo, max_$_hi);
  }
});
$p.xL = (function(minSmallest_$_lo, minSmallest_$_hi, minLargest_$_lo, minLargest_$_hi, maxSmallest_$_lo, maxSmallest_$_hi, maxLargest_$_lo, maxLargest_$_hi) {
  if (((minSmallest_$_hi === minLargest_$_hi) ? ((minSmallest_$_lo >>> 0) > (minLargest_$_lo >>> 0)) : (minSmallest_$_hi > minLargest_$_hi))) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), "Smallest minimum value must be less than largest minimum value");
  }
  if (((maxSmallest_$_hi === maxLargest_$_hi) ? ((maxSmallest_$_lo >>> 0) > (maxLargest_$_lo >>> 0)) : (maxSmallest_$_hi > maxLargest_$_hi))) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), "Smallest maximum value must be less than largest maximum value");
  }
  if (((minLargest_$_hi === maxLargest_$_hi) ? ((minLargest_$_lo >>> 0) > (maxLargest_$_lo >>> 0)) : (minLargest_$_hi > maxLargest_$_hi))) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), "Minimum value must be less than maximum value");
  }
  return new $j_java$002etime$002etemporal$002e$002dValue$002dRange.$c_Ljava_time_temporal_ValueRange(minSmallest_$_lo, minSmallest_$_hi, minLargest_$_lo, minLargest_$_hi, maxSmallest_$_lo, maxSmallest_$_hi, maxLargest_$_lo, maxLargest_$_hi);
});
var $d_Ljava_time_temporal_ValueRange$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ValueRange$, "java.time.temporal.ValueRange$", ({
  mJ: 1
}));
export { $d_Ljava_time_temporal_ValueRange$ as $d_Ljava_time_temporal_ValueRange$ };
var $n_Ljava_time_temporal_ValueRange$;
function $m_Ljava_time_temporal_ValueRange$() {
  if ((!$n_Ljava_time_temporal_ValueRange$)) {
    $n_Ljava_time_temporal_ValueRange$ = new $c_Ljava_time_temporal_ValueRange$();
  }
  return $n_Ljava_time_temporal_ValueRange$;
}
export { $m_Ljava_time_temporal_ValueRange$ as $m_Ljava_time_temporal_ValueRange$ };
